import * as S from "./InputSelect.style";
import { ChangeEvent } from "react";
import { InputProps, Inputs } from "..";

interface InputSelectProps extends InputProps {
  ref?: React.LegacyRef<HTMLSelectElement>;
  onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
  value?: string;
  options?: any;
  isPlaceholder?: boolean;
  placeholderDisabled?: boolean;
  displayKey?: string;
  valueKey?: string;
}

export const InputSelect = (props: InputSelectProps) => {
  return (
    <Inputs
      label={props.label ? props.label : undefined}
      required={props.required ? props.required : false}
    >
      <S.SelectBox>
        <S.Select
          ref={props.ref}
          name={props.name}
          onChange={props.onChange}
          disabled={props.disabled}
          value={props.value || ""}
        >
          {props.isPlaceholder && (
            <S.Placeholder value="" disabled={props.placeholderDisabled}>
              {props.placeholder}
            </S.Placeholder>
          )}
          {props.options &&
            props.options.map((item: any) => {
              const itemValue = props.valueKey
                ? item[props.valueKey]
                : item.value;
              return (
                <option key={`${item.label}_${itemValue}`} value={itemValue}>
                  {props.displayKey ? item[props.displayKey] : item.label}
                </option>
              );
            })}
        </S.Select>
      </S.SelectBox>
    </Inputs>
  );
};
